import React, { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom";
import { Button } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Swal from 'sweetalert2';

import request from '../../../Helpers/API';
import PlantillaScreen from '../../helpers/PlantillaScreen';
import { LoaderScreen } from '../../components/LoaderScreen';
import ModalAgregarLineasScorecard from './ModalAgregarLineasScorecard';

// Alta/Edición se realizan siempre por modal (ModalAgregarLineasScorecard).
const ID_LINEA_NUEVA = -999;
const TITULO = "LINEAS SCORECARD";
const LOADER_INICIAL = { mostrar: false, alerta: false, error: false, mensaje: "" };

export const LineasScorecardScreen = () => {
    const history = useHistory();

    const [data, setData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [idlinea, setIdlinea] = useState(ID_LINEA_NUEVA);
    const [loader, setLoader] = useState(LOADER_INICIAL);

    const handleOpenModal = (idlineaSeleccionada) => {
        setIdlinea(idlineaSeleccionada);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const onHome = () => {
        history.push("/Ventas/Main");
    };

    // Al cerrar el modal se recarga el listado para reflejar altas y ediciones.
    useEffect(() => {
        if (openModal) return;

        setLoader((prev) => ({ ...prev, mostrar: true }));
        request
            .get(`LineasScorecard/Listado`)
            .then((result) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                setData(Array.isArray(result) ? result : []);
            })
            .catch(() => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                setData([]);
                Swal.fire(
                    TITULO,
                    "No fue posible cargar el listado de líneas. Intente nuevamente o contacte al administrador.",
                    "error"
                );
            });
    }, [openModal]);

    return (
        <PlantillaScreen
            titulo={TITULO}
            className_main={1}
            className={"lineas-scorecard-main-screen"}
        >
            <LoaderScreen loader={loader} />
            <div>
                <div className='lineas-scorecard-encabezado'>
                    <div className='lineas-scorecard-container'>
                        <div className='lineas-scorecard-boton-agregar-container'>
                            <Button
                                variant="contained"
                                className='lineas-scorecard-agregar-nueva-linea'
                                onClick={() => handleOpenModal(ID_LINEA_NUEVA)}
                            >
                                Agregar
                            </Button>
                        </div>
                        <div className="lineas-scorecard-listado-Container">
                            <div className='lineas-scorecard-tabla-listado scroll-4'>
                                <table>
                                    <thead>
                                        <tr>
                                            <th className="ancho-90">Línea</th>
                                            <th className="ancho-10"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((menu) => (
                                            <tr key={menu.idlinea}>
                                                <td className="ancho-90">{menu.descripcion}</td>
                                                <td className="ancho-10">
                                                    <CreateIcon
                                                        onClick={() => handleOpenModal(menu.idlinea)}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* El modal sólo consulta la API cuando open === true. */}
                    <ModalAgregarLineasScorecard
                        open={openModal}
                        handleCloseModal={handleCloseModal}
                        idlinea={idlinea}
                    />
                </div>
                <div>
                    <div className='home' onClick={() => onHome()}>
                        <ArrowBackIcon /> Regresar
                    </div>
                </div>
            </div>
        </PlantillaScreen>
    );
};
